module.exports = __webpack_public_path__ + "media/images/review/ico-review-heart-add-b9a737808ef783131352bec7faac24bf.svg";